// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterIncomeVerificationWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterIncomeVerificationWebApiHandler_acceptTerms,
  CappsRenterIncomeVerificationWebApiHandler_completePlaidLink,
  CappsRenterIncomeVerificationWebApiHandler_createLinkToken,
  CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification,
  CappsRenterIncomeVerificationWebApiHandler_deleteReport,
  CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons,
  CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_Path,
  CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus,
  CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_Path,
  CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport,
  CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_Path,
  CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds,
  CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_Path,
  CappsRenterIncomeVerificationWebApiHandler_getTerms,
  CappsRenterIncomeVerificationWebApiHandler_getTerms_Path,
  CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport,
  CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_Path,
  CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus,
  CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_Path,
  CappsRenterIncomeVerificationWebApiHandler_shareReport,
} from '@zg-rentals/ts-capps-client';

import type {
  AcceptIncomeVerificationTermsWebApiRequestDto,
  AcceptIncomeVerificationTermsWebApiResponseDto,
  CompletePlaidLinkRequestDto,
  CreateLinkTokenRequestDto,
  CreateLinkTokenResponseDto,
  DeclineIncomeVerificationWebApiRequestDto,
  GetDeclineReasonsWebApiResponseDto,
  GetIncomeVerificationTermsWebApiResponseDto,
  ShareReportRequestDto,
  WebGetIncomeInsightsResponseDto,
  WebGetIncomeVerificationReportStatusResponseDto,
  WebGetRequestedApplicationIdsResponseDto,
  WebGetVerifiedIncomeRequestAndReportStatusResponseDto,
} from '@zg-rentals/ts-capps-client';

interface GetVerifiedIncomeRequestAndReportStatusParams {
  applicationId: string;
}

export interface CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Args {
  postData: AcceptIncomeVerificationTermsWebApiRequestDto;
}

export type CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Options = UseMutationOptions<
  AcceptIncomeVerificationTermsWebApiResponseDto,
  unknown,
  CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Args
>;

export const useCappsRenterIncomeVerificationWebApiHandler_acceptTerms = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Args) =>
      CappsRenterIncomeVerificationWebApiHandler_acceptTerms(args.postData, httpClient),
  });
};

export interface CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Args {
  postData: CompletePlaidLinkRequestDto;
}

export type CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Args
>;

export const useCappsRenterIncomeVerificationWebApiHandler_completePlaidLink = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Args) =>
      CappsRenterIncomeVerificationWebApiHandler_completePlaidLink(args.postData, httpClient),
  });
};

export interface CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Args {
  postData: CreateLinkTokenRequestDto;
}

export type CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Options = UseMutationOptions<
  CreateLinkTokenResponseDto,
  unknown,
  CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Args
>;

export const useCappsRenterIncomeVerificationWebApiHandler_createLinkToken = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Args) =>
      CappsRenterIncomeVerificationWebApiHandler_createLinkToken(args.postData, httpClient),
  });
};

export interface CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Args {
  postData: DeclineIncomeVerificationWebApiRequestDto;
}

export type CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Args
>;

export const useCappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Args) =>
      CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification(args.postData, httpClient),
  });
};

export type CappsRenterIncomeVerificationWebApiHandler_deleteReport_Options = UseMutationOptions<void, unknown, void>;

export const useCappsRenterIncomeVerificationWebApiHandler_deleteReport = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_deleteReport_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsRenterIncomeVerificationWebApiHandler_deleteReport(httpClient),
  });
};

export type CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_Options = UseQueryOptions<
  GetDeclineReasonsWebApiResponseDto,
  unknown,
  GetDeclineReasonsWebApiResponseDto,
  readonly [string]
>;

const CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_GetKey = () =>
  [CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_Path] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_GetKey(),
    queryFn: () => CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getDeclineReasons = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getDeclineReasons.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_GetKey;

export type CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_Options = UseQueryOptions<
  WebGetIncomeVerificationReportStatusResponseDto,
  unknown,
  WebGetIncomeVerificationReportStatusResponseDto,
  readonly [string]
>;

const CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_GetKey = () =>
  [CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_Path] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_GetKey(),
    queryFn: () => CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus = ({
  httpClient,
  ...options
}: Omit<
  CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_Options,
  'queryFn' | 'queryKey'
> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_GetKey;

export type CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_Options = UseQueryOptions<
  WebGetIncomeInsightsResponseDto,
  unknown,
  WebGetIncomeInsightsResponseDto,
  readonly [string]
>;

const CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_GetKey = () =>
  [CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_Path] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_GetKey(),
    queryFn: () => CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_GetKey;

export type CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_Options = UseQueryOptions<
  WebGetRequestedApplicationIdsResponseDto,
  unknown,
  WebGetRequestedApplicationIdsResponseDto,
  readonly [string]
>;

const CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_GetKey = () =>
  [CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_Path] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_GetKey(),
    queryFn: () => CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_GetKey;

export type CappsRenterIncomeVerificationWebApiHandler_getTerms_Options = UseQueryOptions<
  GetIncomeVerificationTermsWebApiResponseDto,
  unknown,
  GetIncomeVerificationTermsWebApiResponseDto,
  readonly [string]
>;

const CappsRenterIncomeVerificationWebApiHandler_getTerms_GetKey = () =>
  [CappsRenterIncomeVerificationWebApiHandler_getTerms_Path] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getTerms_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getTerms_GetKey(),
    queryFn: () => CappsRenterIncomeVerificationWebApiHandler_getTerms(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getTerms = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_getTerms_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getTerms_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getTerms.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getTerms_GetKey;

export type CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_Options = UseQueryOptions<
  WebGetIncomeInsightsResponseDto,
  unknown,
  WebGetIncomeInsightsResponseDto,
  readonly [string]
>;

const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_GetKey = () =>
  [CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_Path] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_GetKey(),
    queryFn: () => CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_GetKey;

export type CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_Options =
  UseQueryOptions<
    WebGetVerifiedIncomeRequestAndReportStatusResponseDto,
    unknown,
    WebGetVerifiedIncomeRequestAndReportStatusResponseDto,
    readonly [string, GetVerifiedIncomeRequestAndReportStatusParams]
  >;

const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_GetKey = (
  getParams: GetVerifiedIncomeRequestAndReportStatusParams,
) => [CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_Path, getParams] as const;

export const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_queryOptions = (
  getParams: GetVerifiedIncomeRequestAndReportStatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_GetKey(getParams),
    queryFn: () =>
      CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus = (
  getParams: GetVerifiedIncomeRequestAndReportStatusParams,
  {
    httpClient,
    ...options
  }: Omit<
    CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useCappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus.getKey =
  CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_GetKey;

export interface CappsRenterIncomeVerificationWebApiHandler_shareReport_Args {
  postData: ShareReportRequestDto;
}

export type CappsRenterIncomeVerificationWebApiHandler_shareReport_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterIncomeVerificationWebApiHandler_shareReport_Args
>;

export const useCappsRenterIncomeVerificationWebApiHandler_shareReport = ({
  httpClient,
  ...options
}: Omit<CappsRenterIncomeVerificationWebApiHandler_shareReport_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterIncomeVerificationWebApiHandler_shareReport_Args) =>
      CappsRenterIncomeVerificationWebApiHandler_shareReport(args.postData, httpClient),
  });
};
